import { writable } from 'svelte/store';
export let stylesBackground = writable('white');
export let stylesColor = writable('black');
export let stylesScale = writable(1);